export default {
  TITLE: {
    progress: {
      milestone: 'exmp_chart_milestone_title',
      status: 'exmp_chart_project_by_status_title',
      projectsList: 'exmp_chart_project_list_title',
      schedule: 'exmp_chart_project_schedule_title',
      monthProgress: 'exmp_chart_progress_by_month_title',
    },
    budget: {
      budgetByProjects: 'exmp_chart_budget_project_title',
      budgetByMonth: 'exmp_chart_budget_by_month_title',
    },
    time: {
      timeByProjects: 'exmp_chart_time_project_title',
      timeByMonth: 'exmp_chart_time_by_month_title',
    },
  },

  FILTER_NAMES: {
    progressReports: 'reportsProgress',
    budgetReports: 'reportsBudget',
    timeReports: 'reportsTime',
  },
};
